<template>
    <div class="copyright">
        <p>Copyright &copy; <span>Wilson</span> Onjore</p>
    </div>
</template>